import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const Branches = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Name' },
    { key: 'city', label: 'City' },
    { key: 'state', label: 'State' },
    { key: 'is_head_office', label: 'Head Office' },
    { key: 'is_active', label: 'Status' },
  ];

  const formFields = [
    { name: 'organization_id', label: 'Organization ID', required: true, type: 'number', placeholder: 'Organization ID' },
    { name: 'code', label: 'Code', required: true, placeholder: 'BR001' },
    { name: 'name', label: 'Name', required: true, placeholder: 'Branch Name' },
    { name: 'address', label: 'Address', type: 'textarea', fullWidth: true },
    { name: 'city', label: 'City', placeholder: 'City' },
    { name: 'state', label: 'State', placeholder: 'State' },
    { name: 'country', label: 'Country', placeholder: 'Country' },
    { name: 'pincode', label: 'Pincode', placeholder: 'Pincode' },
    { name: 'phone', label: 'Phone', placeholder: 'Phone Number' },
    { name: 'email', label: 'Email', type: 'email', placeholder: 'email@branch.com' },
    { name: 'is_head_office', label: 'Is Head Office', type: 'boolean', defaultValue: false },
    { name: 'is_active', label: 'Status', type: 'boolean', defaultValue: true },
  ];

  return (
    <MasterLayout
      title="Branches"
      endpoint="branches"
      columns={columns}
      formFields={formFields}
      permissions={['ADMIN']}
    />
  );
};

export default Branches;
